import { useMutation, UseMutationOptions } from 'react-query';

import { userApi } from 'src/Services/API';

export const useUpdateLastAssetNameCompletionDate = (
  options?: UseMutationOptions<void, unknown, void>
) => {
  return useMutation<void, unknown, void>(
    ['update-last-asset-name-completion-date'],
    async () => {
      const response = await userApi.userControllerUpdateLastAssetNameCompletionDate();
      return response.data;
    },
    options
  );
};

export default useUpdateLastAssetNameCompletionDate;
